__turbopack_context__.v({
  "artikkelPreview": "ArtikkelPreview-module__THqRBG__artikkelPreview",
  "artikkelPreviewTekst": "ArtikkelPreview-module__THqRBG__artikkelPreviewTekst",
});
